import { ReadOnlyFields } from "@/components/FormLayout/types";
import { PanelSettings } from "@/types";
import { getTranslation } from "@/utils/cljs_data";
export const MOCK_FILTERS_URL = `https://629d4.wiremockapi.cloud/filters`;
export const MOCK_FOLDERS_URL = `https://629d4.wiremockapi.cloud/folders`;
export const STORYBOOK_HOST = `storybook.practitest.app`;
export const DEFAULT_FILTER_KEY = "_DEFAULT_";
export const DEFAULT_FOLDER_KEY = "_DEFAULT_";
export const ENABLE_CACHE = true;
export const MIN_CRITERIA_LENGTH: number = 2;
export const AUTO_FILTER_CACHE_DURATION_IN_SECONDS: number = 60 * 1000;
export const DEFAULT_IN_MEMORY_CACHE_DURATION: number = 5 * 1000;

export const BIG_FILTER_CACHE_DURATION_IN_SECONDS: number = 60 * 60 * 1000;
export const MAX_FILTERS_SAVED_TO_CACHE = 3000;
export const IS_FILTERS_CACHE_ENABLE = true;
export const IS_FOLDERS_CACHE_ENABLE = true;
export const IS_AUTO_AFILTER_CACHE_ENABLE = true;
export const TREE_LEFT_PADDING = 20;
export const CHILD_FOLDER_TREE_LEFT_PADDING = 4;
export const COLLAPSE_ICON_WIDTH = 30;
export const AUTO_FILTER_ICON_WIDTH = 20;
export const LEFT_INDANTATION_WIDTH = 16;
export const ROOT_LEAF_PADDING = 24;
export const AUTO_FILTER_TREE_NAME_LEFT_PADDING = 6;
export const REG_TREE_NAME_LEFT_PADDING = 3;
export const AUTO_AFILTER_CACHE_KEY = "auto-filter-item-";
export const MAX_TREE_LEVELS = 4;
export const GENERIC_ERROR_MESSAGE = getTranslation(
  "filter-tree.message.generic-error",
  "Oops, an error occurred. Please try reloading the page.",
);
export const FILTERS_TAB_KEY = "filters";
export const FOLDERS_TAB_KEY = "folders";
export const IS_FAVORITE_DEBUG = false;

export const defaultSettings: PanelSettings = {
  enableSearch: true,
  enableAddFilters: false,
  enableAddFolders: false,
  enableFolders: false,
  enableSettings: false,
  maxNumberOfFavorites: 15,
  enableResize: false,
  cacheVersion: "",
  moduleEditPermissions: [],
  disableBookmarks: false,
  instanceViewMode: false,
};

const NAME_FORMATTER_NO_XSS = {
  regex: /^[\w\p{P}@\s]+$/u,
  message: "Name can only contain letters, digits, punctuation and spaces",
};

export const validations = {
  FILTER_NAME: [
    {
      regex: /^.{3,}$/,
      message: "Name is too short (minimum is 3 characters)",
    },
    {
      regex: /^.{0,255}$/,
      message: "Name is too long (maximum is 255 characters)",
    },
    NAME_FORMATTER_NO_XSS,
  ],
  FOLDER_NAME: [
    {
      regex: /^.{2,}$/,
      message: "Name is too short (minimum is 2 characters)",
    },
    {
      regex: /^.{0,30}$/,
      message: "Name is too long (maximum is 30 characters)",
    },
    NAME_FORMATTER_NO_XSS,
  ],
};

export const INTEGRATION_SYSTEM_NAME = "integration_fields";

export const READ_ONLY_FIELDS: ReadOnlyFields = {
  test: { fields: ["test_type"] },
};

export const EXCLUDED_FIELDS: ReadOnlyFields = {
  test: { fields: ["scenario", "preconditions"] },
  run: { fields: ["run_run_status", "run_type"] },
};

export const HIDDEN_FIELDS: ReadOnlyFields = {
  requirement: { fields: ["requirement_status"] },
};
